import React, { useMemo, useState } from "react";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { useTranslation } from "react-i18next";
import EContractUK from "./EContractUK";
import PrivacyUK from "./PrivacyUK";
import TermsOfUseUK from "./TermsOfUseUK";
import "./index.scss";

function DocumentViewer({ documentName, hideLanguageSelect = false }) {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  function changeViewLanguage(e) {
    setLanguage(e.target.value);
  }

  const documentContent = useMemo(() => {
    switch (documentName) {
      case "eContract":
        switch (language) {
          case "uk":
            return <EContractUK />;
          default:
            return <EContractUK />;
        }
      case "privacy":
        switch (language) {
          case "uk":
            return <PrivacyUK />;
          default:
            return <PrivacyUK />;
        }
      case "termsOfUse":
        switch (language) {
          case "uk":
            return <TermsOfUseUK />;
          default:
            return <TermsOfUseUK />;
        }
      default:
        return "";
    }
  }, [documentName, language]);

  return (
    <div className="documentViewer">
      {!hideLanguageSelect && (
        <FormControl className="languageSelect">
          <RadioGroup row onChange={changeViewLanguage} defaultValue={language}>
            <FormControlLabel value="en" control={<Radio color="primary" />} label="EN" labelPlacement="top" />
            <FormControlLabel value="uk" control={<Radio color="primary" />} label="UA" labelPlacement="top" />
            <FormControlLabel value="ru" control={<Radio color="primary" />} label="RU" labelPlacement="top" />
          </RadioGroup>
        </FormControl>
      )}
      {documentContent}
    </div>
  );
}

export default DocumentViewer;
